import React from 'react'
import {Dialog, Button, ButtonArea, TextArea} from 'react-weui'

class ClassroomReportFileDialog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            reason: ''
        }
    }

    render() {
        return (
            <Dialog title={'其他'} show={true} style={{ zIndex: 99999 }}>
                <TextArea
                    placeholder={'举报详细说明（必填）'}
                    rows={3}
                    onChange={(e) => this.setState({reason: e.target.value})}
                />
                <ButtonArea direction="horizontal">
                    <Button type="default" plain onClick={this.props.onBack}>返回</Button>
                    <Button type="primary" plain onClick={() => this.props.onReport(this.state.reason)}>举报</Button>
                </ButtonArea>
            </Dialog>
        )
    }
}

export default ClassroomReportFileDialog



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomReportFileDialog.js